<template>
  <div class="loader">
    <div class="container-fluid">
      <div class="row align-items-center no-gutters" style="">
        <div class="col text-center">
          <div class="d-inline-block pt-5">
            <breeding-rhombus-spinner
              :animation-duration="2000"
              :size="65"
              color="#ff1d5e"
              />
          </div>
          <div class="mt-2">
            <p class="lead">
              Un momento por favor, estamos procesando tu pago y creando tu Membresía Hispano Club
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BreedingRhombusSpinner } from 'epic-spinners'
export default {
  name: 'Loader',
  props: ['show', 'error'],
  components: {
    BreedingRhombusSpinner
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.loader {
  position: absolute;
  background: rgba($color: white, $alpha: 0.95);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue